/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import restClient from '../../app/helpers/restClient';

const RESOURCE_PAGE_FACADE = '/user';
const RESOURCE_ROOT_FACADE = '/profile/site/';

const getEmailOptInSubscribe = ({
    wcEnv, jwtToken, brandId, email,
}) => {
    const env = wcEnv;
    env.rootUri = RESOURCE_ROOT_FACADE;

    const resourcePage = `${brandId}${RESOURCE_PAGE_FACADE}/${email}`;

    return restClient.getFacade(env, resourcePage, jwtToken)
        .then((response) => response);
};

export default getEmailOptInSubscribe;
